import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-createnewproposal',
  templateUrl: './createnewproposal.component.html',
  styleUrl: './createnewproposal.component.css'
})
export class CreatenewproposalComponent implements OnInit {

  interventionOptions: string[] = ['Option 1', 'Option 2', 'Option 3'];
  componentOptions: string[] = ['Component A', 'Component B', 'Component C'];
  
  form = new FormGroup({
    intervention: new FormControl('', [Validators.required]),
    component: new FormControl('', [Validators.required]),
    targetMSME: new FormControl('', [Validators.required]),
    noOfEvents: new FormControl('', [Validators.required]),
    briefBackgroundofIA: new FormControl('', [Validators.required]),
    summaryScale: new FormControl('', [Validators.required]),
    programName: new FormControl('', [Validators.required]),
    targetMSMEs: new FormControl('', [Validators.required]),
    measurableOutcoms: new FormControl('', [Validators.required]),
    implementationDetails: this.fb.array([this.createImplementationDetail()]),
    geographyTimeline: this.fb.array([this.createGeographyTimeline()]),
    proposedDate: new FormControl('', [Validators.required]),
    proposedDistrict: new FormControl('', [Validators.required]),
    proposedVenue: new FormControl('', [Validators.required]),
    proposedNoOfWorkshop: new FormControl('', [Validators.required]),
    totalTarget: new FormControl('', [Validators.required]),
    curriculumDetails: new FormControl('', [Validators.required]),
    workshopDuration: new FormControl('', [Validators.required]),
    trainersQualification: new FormControl('', [Validators.required]),
    beneficiaryCriteria: new FormControl('', [Validators.required]),
    detailedFinancials: this.fb.array([this.createDetailedFinancial()]),
    interventionMilestones: this.fb.array([this.createInterventionMilestone()])
  })
  
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void { }

  get implementationDetails(): FormArray {
    return this.form.get('implementationDetails') as FormArray;
  }

  createImplementationDetail(): FormGroup {
    return this.fb.group({
      engagementPartner: ['', Validators.required],
      district: [this.interventionOptions[0], Validators.required],
      noOfWorkshop: ['', [Validators.required, Validators.min(1)]],
      target: ['', [Validators.required, Validators.min(1)]]
    });
  }

  addMore(): void {
    this.implementationDetails.push(this.createImplementationDetail());
  }
  get geographyTimeline(): FormArray {
    return this.form.get('geographyTimeline') as FormArray;
  }

  createGeographyTimeline(): FormGroup {
    return this.fb.group({
      proposedDate: [''],
      proposedDistrict: [''],
      proposedVenue: [''],
      proposedNoOfWorkshop: [''],
      totalTarget: ['']
    });
  }

  saveForm(): void {
    if (this.form.valid) {
      // Implement saving logic here
    } else {
    }
  }

  addGeographyTimeline(): void {
    this.geographyTimeline.push(this.createGeographyTimeline());
  }

  get detailedFinancials(): FormArray {
    return this.form.get('detailedFinancials') as FormArray;
  }

  createDetailedFinancial(): FormGroup {
    return this.fb.group({
      district: [''],
      cost: ['', Validators.required]
    });
  }

  addDetailedFinancial(): void {
    this.detailedFinancials.push(this.createDetailedFinancial());
  }

  get interventionMilestones(): FormArray {
    return this.form.get('interventionMilestones') as FormArray;
  }

  createInterventionMilestone(): FormGroup {
    return this.fb.group({
      milestone: [''],
      projectStartDate: [''],
      durationInMonths: [''],
      estimatedProjectClosure: ['']
    });
  }

  addInterventionMilestone(): void {
    this.interventionMilestones.push(this.createInterventionMilestone());
  }

  onSubmit(): void {
    if (this.form.valid) {
    } else {
    }
  }

  onCancel(): void {
    this.form.reset();
  }
}
